import {Icon, IconName} from '@wandb/weave/components/Icon';
import React from 'react';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import * as S from './QuickStart.styles';

type QuickStartIconProps = {
  name: IconName;
  [x: string]: any;
};

export const QuickStartIcon = ({name, ...props}: QuickStartIconProps) => {
  return (
    <S.QuickStartIcon>
      <Icon name={name} {...props} />
    </S.QuickStartIcon>
  );
};
